'use strict';

angular.module('amexReconciliationApp')
  .component('printButton', {
    templateUrl: 'scripts/views/components/print-button.html',
    controller: function (TransactionSearchModel,
                          TransactionSortModel,
                          SelectedTransactionService,
                          $element,
                          $httpParamSerializer,
                          $sce,
                          $timeout) {
      var self = this;

      self.transactionIds = [];

      self.isDisabled = function() {
        return _.isEmpty(TransactionSortModel.transactions());
      };

      self.print = function () {
        self.transactionIds = self.getTransactionIds();
        $timeout(function () {
          $element.find('#print-form').submit();
          self.transactionIds = [];
        }, 0, false);
      };

      self.getPdfUrl = function () {
        var url = TransactionSearchModel.url('print');
        var qs = $httpParamSerializer(TransactionSearchModel.queryParams());
        return $sce.trustAsResourceUrl(url + '?' + qs);
      };

      self.getTransactionIds = function() {
        var transactionIds = _.map(SelectedTransactionService.selectedTransactions(), 'id');
        if (transactionIds.length === 0) {
          transactionIds = _.map(TransactionSortModel.transactions(), 'id');
        }
        return _.join(transactionIds, ',');
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/printButton.js
// module id = 467
// module chunks = 0